import React from 'react';
import { values } from 'lodash';
import { Index } from 'react-instantsearch/dom';
import { connectStateResults } from 'react-instantsearch/connectors';
import * as INDEX_KEYS from '../constants/indexKeys';
import Topics from './Topics';
import LessonsAndPaths from './LessonsAndPaths';
import LessonContent from './LessonContent';
import NoResults from './NoResults';
import InsufficientResults from './InsufficientResults';

const Results = ({
  allSearchResults,
  indexes,
  searching,
  searchResults,
  features,
  expert,
}) => {
  const hasResults = values(allSearchResults).some(
    results => results && results.nbHits > 0,
  );

  return (
    <div>
      <Index indexName={indexes[INDEX_KEYS.TAGS]}>
        <Topics />
      </Index>
      <Index indexName={indexes[INDEX_KEYS.LESSONS_PATHS]}>
        <LessonsAndPaths />
      </Index>
      <Index indexName={indexes[INDEX_KEYS.SECTIONS_ELEMENTS]}>
        <LessonContent />
      </Index>
      {hasResults && <InsufficientResults />}
      {!searching && !hasResults && (
        <NoResults query={searchResults && searchResults.query} />
      )}
    </div>
  );
};

export default connectStateResults(Results);
